import type { Theme, ThemeOptions } from '@mui/material/styles';

/** Field chrome uses `Input.theme` classNames — no extra overrides yet. */
export function timePickerThemeComponents(_theme: Theme): ThemeOptions['components'] {
  return {};
}
